import type { ColumnDef } from "@tanstack/react-table";
import { capitalize, highlightText } from "@repo/utils";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import type { ProductModifierGroup } from "~/providers/product-provider";
import { SettingsHeader } from "~/components/layout/settings-header";
import { DataTable } from "~/components/miscellaneous/data-table";
import { DataTableColumnHeader } from "~/components/miscellaneous/data-table-column-header";
import { useProduct } from "~/hooks/use-product";
import { useProductModifierGroupManager } from "~/managers/use-product-modifier-group-manager";

export const Route = createFileRoute(
  "/_main/settings/_layout/modifier-groups/",
)({
  component: ModifierGroups,
});

function ModifierGroups() {
  const { t } = useTranslation("common");
  const { modifierGroups } = useProduct();
  const { openDialog } = useProductModifierGroupManager();

  const columns: ColumnDef<ProductModifierGroup>[] = [
    {
      id: t("name"),
      accessorKey: "name",
      filterFn: "includesString",
      size: 200,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("name")} />
      ),
      cell: ({ row: { original: productModifierGroup }, table }) => {
        const globalFilter = table.getState().globalFilter as string;
        return (
          <p
            dangerouslySetInnerHTML={{
              __html:
                highlightText(productModifierGroup.name, globalFilter) ?? "",
            }}
          ></p>
        );
      },
    },
  ];

  return (
    <>
      <SettingsHeader
        title={t("ProductModifierGroup.product_modifier_groups")}
        buttonAction={() => openDialog()}
        buttonLabel={capitalize(
          t("ProductModifierGroup.new_product_modifier_group"),
        )}
      />

      <DataTable
        defaultSorting={[{ id: t("name"), desc: false }]}
        columns={columns}
        data={modifierGroups}
        onSelect={openDialog}
      />
    </>
  );
}
